/* eslint-disable */
// NOTE :: DO NOT EDIT :: this file is automatically generated by generate-environment-variables.js node script

export const envVariables: { [key: string]: string } = {
  CIRCLE_TAG: 'prod-purposeful-v128',
  PROJECT: 'purposeful',
  PRODUCT: 'purposeful',
};
export const latestTag: string = 'prod-purposeful-v128';
export const latestVersion: string = 'v128';
export const versions: { app: { [key: string]: string }, branch: string, npm_version: string, revision: string } = {
  app: {
    purposeful: '8.0.0',
    insightful: '3.1.2',
  },
  branch: 'HEAD',
  npm_version: '167.0.0',
  revision: '12a8d29f4',
};
/* eslint-enable */
